import { render, staticRenderFns } from "./UploadQrDatabin.vue?vue&type=template&id=0ac52ab6&scoped=true&lang=pug&"
import script from "./UploadQrDatabin.vue?vue&type=script&lang=js&"
export * from "./UploadQrDatabin.vue?vue&type=script&lang=js&"
import style0 from "./UploadQrDatabin.vue?vue&type=style&index=0&id=0ac52ab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac52ab6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
